import { useTranslation } from 'react-i18next';

function NotFound() {
    const { t } = useTranslation();

    return (
        <div className="flex min-h-[420px] flex-col items-center justify-center text-2xl">
            <div className="text-4xl font-bold">404</div>
            <div>{t('notFound')}</div>
        </div>
    );
}

export default NotFound;
